import { render } from "./CampaignStatsItem.vue?vue&type=template&id=4c97a52a"
import script from "./CampaignStatsItem.vue?vue&type=script&lang=js"
export * from "./CampaignStatsItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__